import { render, staticRenderFns } from "./pendingDis.vue?vue&type=template&id=6fcab1b6"
import script from "./pendingDis.vue?vue&type=script&lang=js"
export * from "./pendingDis.vue?vue&type=script&lang=js"
import style0 from "./pendingDis.vue?vue&type=style&index=0&id=6fcab1b6&prod&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports